import { AwsUtil } from './../authentication/aws.service';
import {
    NostroLadderProjectionData, NOSTRO_LADDER_PROJECTION_BALANCE_TYPE_PROJECTION
} from './../survival-horizon/nostro-ladder/nostro-ladder-data';
import { ApplicationConfigurationService } from './../application-configuration/application-configuration.service';
import { AppConfig } from './../app.config';
import { Observable, Observer } from 'rxjs';
import { SurvivalHorizonService } from './../survival-horizon/survival-horizon.service';
import { AssumptionData } from './../explain/assumption-data';
import { environment } from './../../environments/environment';
import { AppEnvironment } from './../app-env';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseRestService } from '../service/base-rest.service';
import * as Papa from 'papaparse';
import * as moment from 'moment';
import * as S3 from 'aws-sdk/clients/s3';
import { HistoricalData, HistoricalDataType } from '../histo/historical-data';
import { CurrencyBalanceData } from '../explain/currency-balance-data';
import { InitializationStep } from './initialization-step';
import { ProjectionSummaryData } from '../projection/projection-summary-data';
import {
    Projection,
    PROJECTION_TYPE_PREDICTION,
    PROJECTION_TYPE_EXTERNAL_ASSUMPTION,
    PROJECTION_TYPE_INTERNAL_ASSUMPTION,
    PROJECTION_TARGET_TYPE_CLIENT_GROUP,
    PROJECTION_TARGET_TYPE_EXTERNAL_ACCOUNT,
    PROJECTION_TARGET_TYPE_CREDIT_LINE,
} from '@liquitics/transaction';
import {
    AccountBalanceData,
    SurvivalHorizonData,
    ContractualFlowData,
    ProjectionData,
    WebApiEndpoints,
    ApplicationConfiguration
} from '@liquitics/transaction';

@Injectable()
export class SnapshotService {// extends BaseRestService<any> {

    private currencyBalanceDataByCurrencyThenDate: Map<string, Map<string, CurrencyBalanceData[]>> = new Map();
    private txnContractualFlowDataByCurrencyThenDate: Map<string, Map<string, ContractualFlowData[]>> = new Map();
    private projectionProjectionByCurrencyThenDate: Map<string, Map<string, Projection[]>> = new Map();
    private projectionsByCcyTargetName: Map<string, Projection[]> = new Map();
    private projectionInterdeskFundingDataByCurrencyThenDate: Map<string, Map<string, ProjectionData[]>> = new Map();
    private projectionClientLevelFundingDataByCurrencyThenDate: Map<string, Map<string, ProjectionData[]>> = new Map();
    private predictionDataByCurrencyThenDate: Map<string, Map<string, ProjectionData[]>> = new Map();

    private currencyBalanceSurvivalHorizonDataByCurrency: Map<string, SurvivalHorizonData[]> = new Map();
    private txnSurvivalHorizonDataByCurrency: Map<string, SurvivalHorizonData[]> = new Map();
    private projectionSurvivalHorizonDataByCurrency: Map<string, SurvivalHorizonData[]> = new Map();


    private historicalDataByTypeByCurrency: Map<string, Map<string, HistoricalData[]>> = new Map();
    private accountBalanceDataByCurrency: Map<string, AccountBalanceData[]> = new Map();
    private nostroLadderProjectionDataByCurrency: Map<string, NostroLadderProjectionData[]> = new Map();

    applicationConfiguration: ApplicationConfiguration;

    transactionDataLoaded = false;
    projectionDataLoaded = false;
    currencyBalanceDataLoaded = false;
    historicalDataLoaded = false;

    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        private appConfig: AppConfig) {
        // super(http, cognitoUtil);
    }

    checkIfSnapshotFilesAvailable(todayFolder: string): Promise<boolean> {
        // return new Promise<boolean>((resolve, reject) => {
        //     const s3 = new S3();
        //     const fileNames = new SnapshotFileNames(todayFolder);
        //     Promise.all(fileNames.allFileNames().map((fileName: string) => {
        //         const params = {
        //             Bucket: this.appConfig.getTenantInfo().bucket,
        //             Key: fileName
        //         } as AWS.S3.Types.HeadObjectRequest;
        //         return s3.headObject(params).promise();
        //     }))
        //         .then(() => {
        //             resolve(true);
        //         })
        //         .catch((err: any) => {
        //             reject(err);
        //             return;
        //         });
        // });
        return Promise.resolve(true);
    }

    initializationSteps(): InitializationStep[] {
        console.log('Initializing Snapshot Data');
        const todayFolder = this.appConfig.getTodayStartUTC().format('YYYY/MM/DD');
        const fileNames = new SnapshotFileNames(todayFolder);

        // Transaction Position Data
        const steps: InitializationStep[] = [];

        // const contractualStep = new InitializationStep('Contractual Positions');
        // steps.push(contractualStep);
        // contractualStep.promise = new Promise((resolve, reject) => {
        //     this.initializeSHAndXData(contractualStep.progress,
        //         // 'opening/transactions.csv.gz',
        //         fileNames.contractualFileName,
        //         'date,product type,desk,amount,currency,Direction',
        //         this.txnSurvivalHorizonDataByCurrency,
        //         this.txnContractualFlowDataByCurrencyThenDate,
        //         SurvivalHorizonData.SOURCE_TRANSACTION_SNAPSHOT,
        //         'date',
        //         (row: any, ccy: string, date: string) => {
        //             const amount = row['amount'] || '0';
        //             const xData = new ContractualFlowData();
        //             xData.currency = row['currency'];
        //             xData.direction = row['Direction'];
        //             xData.flowAmount = Number.parseFloat(amount);
        //             xData.openingAmount = xData.flowAmount;
        //             xData.productType = row['product type'];
        //             xData.desk = row['desk'];
        //             xData.date = date;
        //             return xData;
        //         },
        //         (xArray: ContractualFlowData[]) => {
        //             return xArray;
        //         },
        //         (xData: ContractualFlowData, shData: SurvivalHorizonData) => {
        //             shData.inAmount = (xData.flowAmount >= 0) ? xData.flowAmount : 0;
        //             shData.outAmount = (xData.flowAmount < 0) ? xData.flowAmount : 0;
        //         },
        //     )
        //         .then(() => {
        //             this.transactionDataLoaded = true;
        //             contractualStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             contractualStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });

        // Projection Data
        // const projectionStep = new InitializationStep('Projection Data');
        // steps.push(projectionStep);
        // projectionStep.promise = new Promise((resolve, reject) => {
        //     this.initializeSHAndXData(projectionStep.progress,
        //         fileNames.projectionFileName,
        //         null,
        //         this.projectionSurvivalHorizonDataByCurrency,
        //         this.projectionProjectionByCurrencyThenDate,
        //         SurvivalHorizonData.SOURCE_ASSUMPTION_SNAPSHOT,
        //         'settleDate',
        //         (row: any, ccy: string, date: string) => {
        //             const amount = row['amount'] || '0';
        //             const xData = new Projection();
        //             xData.currency = row['currency'];
        //             xData.amount = Number.parseFloat(amount);
        //             xData.desk = row['desk'];
        //             xData.targetType = row['targetType'];
        //             xData.targetName = row['targetName'];
        //             xData.direction = row['direction'];
        //             xData.productType = row['productType'];
        //             xData.type = row['type'];
        //             xData.settleDate = row['settleDate'];
        //             xData.account = row['account'];
        //             return xData;
        //         },
        //         (xArray: Projection[]) => {
        //             return xArray;
        //         },
        //         (xData: Projection, shData: SurvivalHorizonData) => {
        //             shData.inAmount = (xData.direction === 'REC') ? xData.amount : 0;
        //             shData.outAmount = (xData.direction === 'PAY') ? xData.amount : 0;
        //         }
        //     )
        //         .then(() => {
        //             projectionStep.progress.next('Analyzing data...');
        //             this.breakDownProjectionData();
        //             this.projectionDataLoaded = true;
        //             projectionStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             projectionStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });



        // Historical Data
        // const historicalStep = new InitializationStep('Historical Data');
        // steps.push(historicalStep);
        // historicalStep.promise = new Promise((resolve, reject) => {
        //     this.loadSnapshotData(
        //         fileNames.historicalFileName,
        //         historicalStep.progress,
        //         null)
        //         .then((parsedCSVData: any[]) => {
        //             try {
        //                 const groupedByCcy = parsedCSVData.reduce((grouped, d) => {
        //                     const key = d.currency;
        //                     grouped[key] = grouped[key] || [];
        //                     grouped[key].push(d);
        //                     return grouped;
        //                 }, {});
        //                 Object.keys(groupedByCcy).forEach((currency: string) => {
        //                     const groupedByType = groupedByCcy[currency].reduce((grouped, d) => {
        //                         const key = d.type;
        //                         grouped[key] = grouped[key] || [];
        //                         grouped[key].push(d);
        //                         return grouped;
        //                     }, {});
        //                     const byTypeMap = new Map<string, HistoricalData[]>();
        //                     this.historicalDataByTypeByCurrency.set(currency, byTypeMap);
        //                     Object.keys(groupedByType).forEach((type: string) => {
        //                         byTypeMap.set(type, groupedByType[type]);
        //                     });
        //                 });
        //             } catch (err) {
        //                 historicalStep.progress.next('Error: ' + err);
        //                 reject(err);
        //                 return;
        //             }
        //         })
        //         .then(() => {
        //             historicalStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             historicalStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });

        // Opening Currency Balance

        // const openingBalanceStep = new InitializationStep('Opening Balance');
        // steps.push(openingBalanceStep);
        // openingBalanceStep.promise = new Promise((resolve, reject) => {
        //     this.initializeSHAndXData(openingBalanceStep.progress,
        //         fileNames.openingBalanceFileName,
        //         'desk,currency,balance',
        //         this.currencyBalanceSurvivalHorizonDataByCurrency,
        //         this.currencyBalanceDataByCurrencyThenDate,
        //         SurvivalHorizonData.SOURCE_CURRENCY_BALANCE_SNAPSHOT,
        //         'date',
        //         (row: any, ccy: string, date: string) => {
        //             const balance = row['balance'] || '0';
        //             const xData = new CurrencyBalanceData();
        //             xData.currency = row['currency'];
        //             xData.balance = Number.parseFloat(balance);
        //             xData.desk = row['desk'];
        //             return xData;
        //         },
        //         (xArray: CurrencyBalanceData[]) => {
        //             return xArray;
        //         },
        //         (xData: CurrencyBalanceData, shData: SurvivalHorizonData) => {
        //             shData.currencyBalanceSnapshotAmount = xData.balance;
        //         }
        //     )
        //         .then(() => {
        //             this.currencyBalanceDataLoaded = true;
        //             openingBalanceStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             openingBalanceStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });

        // Opening Account Balance Data
        // const accountBalanceStep = new InitializationStep('Account Balance');
        // steps.push(accountBalanceStep);
        // accountBalanceStep.promise = new Promise((resolve, reject) => {
        //     this.loadSnapshotData(
        //         fileNames.accountBalanceFileName,
        //         accountBalanceStep.progress,
        //         'account,currency,amount')
        //         .then((parsedCSVData: any[]) => {
        //             try {
        //                 const groupedByCcy = parsedCSVData.reduce((grouped, d) => {
        //                     const key = d.currency;
        //                     d.amount = parseFloat(d.amount);
        //                     grouped[key] = grouped[key] || [];
        //                     grouped[key].push(d);
        //                     return grouped;
        //                 }, {});
        //                 Object.keys(groupedByCcy).forEach((currency: string) => {
        //                     this.accountBalanceDataByCurrency.set(currency, groupedByCcy[currency]);
        //                 });
        //             } catch (err) {
        //                 accountBalanceStep.progress.next('Error: ' + err);
        //                 reject(err);
        //                 return;
        //             }
        //         })
        //         .then(() => {
        //             accountBalanceStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             accountBalanceStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });

        // Account Balance Projection Data
        // const nostroLadderProjectionDataStep = new InitializationStep('Account Balance Projection');
        // steps.push(nostroLadderProjectionDataStep);
        // nostroLadderProjectionDataStep.promise = new Promise((resolve, reject) => {
        //     this.loadSnapshotData(
        //         fileNames.nostroLadderProjectionDataFileName,
        //         nostroLadderProjectionDataStep.progress,
        //         null)
        //         .then((parsedCSVData: any[]) => {
        //             try {
        //                 const groupedByKey = parsedCSVData
        //                     .filter((d) => {
        //                         return d.settleDate === this.appConfig.getTodayString();
        //                     })
        //                     .map((d) => {
        //                         const nostroLadderProjectionData: NostroLadderProjectionData = new NostroLadderProjectionData();
        //                         const amount = parseFloat(d.amount);
        //                         nostroLadderProjectionData.account = d.account;
        //                         nostroLadderProjectionData.startBalance = amount;
        //                         nostroLadderProjectionData.clientGroup = d.clientGroup;
        //                         nostroLadderProjectionData.product = d.productType;
        //                         nostroLadderProjectionData.currency = d.currency;
        //                         nostroLadderProjectionData.balanceType = NOSTRO_LADDER_PROJECTION_BALANCE_TYPE_PROJECTION;
        //                         return nostroLadderProjectionData;
        //                     })
        //                     .reduce((grouped, d) => {
        //                         const key = d.account + '.' + d.clientGroup + '.' + d.product + '.' + d.currency;
        //                         grouped[key] = grouped[key] || [];
        //                         grouped[key].push(d);
        //                         return grouped;
        //                     }, {});
        //                 const reducedProjections = Object.keys(groupedByKey)
        //                     .map((key: string) => {
        //                         return groupedByKey[key]
        //                             .reduce((prev, curr) => {
        //                                 prev.amount += curr.amount;
        //                                 prev.startingProjectedAmount = curr.startingProjectedAmount;
        //                                 return prev;
        //                             })
        //                     });
        //                 const groupedByCcy = reducedProjections
        //                     .reduce((grouped, d) => {
        //                         const key = d.currency;
        //                         grouped[key] = grouped[key] || [];
        //                         grouped[key].push(d);
        //                         return grouped;
        //                     }, {});
        //                 Object.keys(groupedByCcy).forEach((currency: string) => {
        //                     this.nostroLadderProjectionDataByCurrency.set(currency, groupedByCcy[currency]);
        //                 });
        //             } catch (err) {
        //                 nostroLadderProjectionDataStep.progress.next('Error: ' + err);
        //                 reject(err);
        //                 return;
        //             }
        //         })
        //         .then(() => {
        //             nostroLadderProjectionDataStep.progress.next('Done.');
        //             resolve(true);
        //             return;
        //         })
        //         .catch((err: any) => {
        //             nostroLadderProjectionDataStep.progress.next('Error: ' + err);
        //             reject(err);
        //             return;
        //         });
        // });
        return steps;
    }

    protected requestHeaders(token: any): HttpHeaders {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/csv')
            .set('Authorization', String(token))
            .set('Accept', 'application/octet-stream');
        return headers;
    }

    loadSnapshotData(key: string,
        // postParse: (parsedCSVData: any[], observer: Observer<string>) => void,
        observer: Observer<string>,
        useHeader?: boolean,
        headerRow?: string): Promise<any[]> {

        const params = {
            Bucket: this.appConfig.getTenantInfo().bucket,
            Key: key,
        };
        if (key.endsWith('.gz')) {
            params['ResponseContentEncoding'] = 'gzip';
        }
        const headerBuilder = (token: string) => {
            const headers = new HttpHeaders()
                .set('Content-Type', 'text/csv')
                .set('Authorization', String(token));
            return headers;
        };
        return this.awsUtil.webAPICall(WebApiEndpoints.GetCSVs, params, false, headerBuilder)
            .then((data: S3.Types.GetObjectOutput) => {
                let body = (data) ? data.toString() : '';
                if (headerRow) {
                    body = headerRow + '\n' + body;
                }
                const parsed = Papa.parse(body, { header: useHeader });
                observer.next('Parsing data...');
                return parsed.data;
            })

        // return new Promise((resolve, reject) => {
        //     try {

        //         const params = {
        //             Bucket: this.appConfig.getTenantInfo().bucket,
        //             Key: key,
        //         };
        //         if (key.endsWith('.gz')) {
        //             params['ResponseContentEncoding'] = 'gzip';
        //         }
        //         const s3 = new S3();
        //         s3.getObject(params)
        //             .promise()
        //             .then((data: S3.Types.GetObjectOutput) => {
        //                 let body = data.Body.toString();
        //                 if (headerRow) {
        //                     body = headerRow + '\n' + body;
        //                 }
        //                 const parsed = Papa.parse(body, { header: useHeader });
        //                 observer.next('Parsing data...');
        //                 resolve(parsed.data);
        //                 return;
        //             })
        //             .catch((err: any) => {
        //                 reject('Error while requesting data:' + err);
        //                 return;
        //             });
        //     } catch (err) {
        //         reject(err);
        //     };
        // });
    }



    private initializeSHAndXData<T>(observer: Observer<string>,
        snapshotFileKey: string,
        headerRow: string,
        shDataByCurrencyThenDate: Map<string, SurvivalHorizonData[]>,
        xDataByCurrencyThenDate: Map<string, Map<string, T[]>>,
        source: string,
        rowDateFieldName: string,
        xTranslator: (parsedRow: any, ccy: string, date: string) => T,
        xArrayReducer: (xArray: T[]) => T[],
        shPopulator: (x: T, shData: SurvivalHorizonData) => void): Promise<boolean> {

        return new Promise((resolve, reject) => {
            this.loadSnapshotData(snapshotFileKey, observer, true, headerRow)
                .then((parsedCSVData: any[]) => {
                    try {
                        observer.next('Preprocessing data...');
                        const groupedByCcy = parsedCSVData
                            .reduce((grouped, row) => {
                                let key: string = row.currency || 'NA';
                                key = key.toUpperCase();
                                grouped[key] = grouped[key] || [];
                                grouped[key].push(row);
                                return grouped;
                            }, {});
                        Object.keys(groupedByCcy).map(ccy => {
                            const shDataArray: SurvivalHorizonData[] = [];
                            const xDataByDate: Map<string, T[]> = new Map();
                            shDataByCurrencyThenDate.set(ccy, shDataArray);
                            xDataByCurrencyThenDate.set(ccy, xDataByDate);
                            const rows = groupedByCcy[ccy];
                            const groupedByDate = rows.reduce((grouped, row) => {
                                let key = row[rowDateFieldName];
                                if (key) {
                                    const m = moment.utc(key);
                                    key = m.format('YYYY-MM-DD');
                                } else {
                                    key = this.appConfig.getTodayString();
                                }
                                grouped[key] = grouped[key] || [];
                                grouped[key].push(row);

                                return grouped;
                            }, {});
                            Object.keys(groupedByDate).map((date: string) => {
                                const rowsByDate: any[] = groupedByDate[date];
                                if (rowsByDate) {
                                    let xData: T[] = rowsByDate
                                        .map(row => {
                                            const x = xTranslator(row, ccy, date);
                                            // Take care of the SHD too here
                                            const shd = new SurvivalHorizonData();
                                            shd.currency = ccy;
                                            shd.bucket = date;
                                            shd.source = source;
                                            shPopulator(x, shd);
                                            shDataArray.push(shd);
                                            return x;
                                        });
                                    xData = xArrayReducer(xData);
                                    xDataByDate.set(date, xData);
                                }
                            });
                        });
                        resolve(true);
                    } catch (err) {
                        reject(err);
                        return;
                    };
                })
                .catch((err: any) => {
                    reject(err);
                    return;
                });

        });
    }




    private breakDownProjectionData() {
        this.projectionProjectionByCurrencyThenDate.forEach((projectionsByDate, ccy) => {
            if (projectionsByDate) {
                const interdeskFundingDataByDate = new Map<string, ProjectionData[]>();
                this.projectionInterdeskFundingDataByCurrencyThenDate.set(ccy, interdeskFundingDataByDate);
                const clientLevelFundingDataByDate = new Map<string, ProjectionData[]>();
                this.projectionClientLevelFundingDataByCurrencyThenDate.set(ccy, clientLevelFundingDataByDate);
                const predictionDataByDate = new Map<string, ProjectionData[]>();
                this.predictionDataByCurrencyThenDate.set(ccy, predictionDataByDate);
                projectionsByDate.forEach((projections, date) => {
                    const interdeskFundingData: ProjectionData[] = [];
                    interdeskFundingDataByDate.set(date, interdeskFundingData);
                    const clientLevelFundingData: ProjectionData[] = [];
                    clientLevelFundingDataByDate.set(date, clientLevelFundingData);
                    const predictionData: ProjectionData[] = [];
                    predictionDataByDate.set(date, predictionData);
                    if (projections) {
                        projections.forEach(p => {
                            const projectionData = new ProjectionData();
                            projectionData.desk = p.desk;
                            projectionData.date = p.settleDate;
                            projectionData.clientGroup = p.targetName;
                            projectionData.desk = p.desk;
                            projectionData.direction = p.direction;
                            projectionData.productType = p.productType;
                            projectionData.currency = p.currency;
                            projectionData.amount = p.amount;
                            if (p.type === PROJECTION_TYPE_INTERNAL_ASSUMPTION) {
                                // This is not a bug, we are pointing to client as we want to see the internal desk which will
                                // be stored as the client. Desk will always be... myself.. so useless.
                                projectionData.desk = p.targetName;
                                interdeskFundingData.push(projectionData);
                            } else if (p.type === PROJECTION_TYPE_EXTERNAL_ASSUMPTION) {
                                clientLevelFundingData.push(projectionData);
                            } else if (p.type === PROJECTION_TYPE_PREDICTION) {
                                predictionData.push(projectionData);
                            }
                        });
                        if (this.appConfig.getTodayString() === date) {
                            // Now for today's entries, hold onto the projections by projection view key
                            const groupedByCcyTargetName = projections.reduce((grouped, curr: Projection) => {
                                const key = curr.currency + '.' + curr.targetName + '.' + curr.direction;
                                grouped[key] = grouped[key] || [];
                                grouped[key].push(curr);
                                return grouped;
                            }, {});
                            Object.keys(groupedByCcyTargetName).forEach((key: string) => {
                                this.projectionsByCcyTargetName.set(key, groupedByCcyTargetName[key]);
                            });
                        }

                    }
                });
            }
        });
    }

    private groupedOrIndividualEntity(entityName: string, grouped: boolean) {
        return grouped ? 'Various' : entityName;
    }

    contractualFlowData(currency: string, date: string): ContractualFlowData[] {
        const contractualFlowDataByDate = this.txnContractualFlowDataByCurrencyThenDate.get(currency.toUpperCase());
        if (contractualFlowDataByDate) {
            let data;
            if (date) {
                data = contractualFlowDataByDate.get(date);
            } else {
                data = contractualFlowDataByDate.values();
            }
            if (data) {
                return data.map(d => {
                    return Object.assign(new ContractualFlowData(), d);
                });
            }
        }
        return [];
    }

    interdeskFundingData(currency: string, date: string): ProjectionData[] {
        const idfDataByDate = this.projectionInterdeskFundingDataByCurrencyThenDate.get(currency.toUpperCase());
        if (idfDataByDate) {
            let data;
            if (date) {
                data = idfDataByDate.get(date);
            } else {
                data = idfDataByDate.values();
            }
            if (data) {
                return data.map(d => {
                    return Object.assign(new ProjectionData(), d);
                });
            }
        }
        return [];
    }

    clientLevelFundingData(currency: string, date: string): ProjectionData[] {
        const clfDataByDate = this.projectionClientLevelFundingDataByCurrencyThenDate.get(currency.toUpperCase());
        if (clfDataByDate) {
            let data;
            if (date) {
                data = clfDataByDate.get(date);
            } else {
                data = clfDataByDate.values();
            }
            if (data) {
                return data.map(d => {
                    return Object.assign(new ProjectionData(), d);
                });
            }
        }
        return [];
    }

    predictionData(currency: string, date: string): ProjectionData[] {
        const pDataByDate = this.predictionDataByCurrencyThenDate.get(currency.toUpperCase());
        if (pDataByDate) {
            let data;
            if (date) {
                data = pDataByDate.get(date);
            } else {
                data = pDataByDate.values();
            }
            if (data) {
                return data.map(d => {
                    return Object.assign(new ProjectionData(), d);
                });
            }
        }
        return [];
    }

    currencyBalanceData(currency: string): CurrencyBalanceData[] {
        const contractualFlowDataByDate = this.txnContractualFlowDataByCurrencyThenDate.get(currency.toUpperCase());
        if (contractualFlowDataByDate) {
            const data = contractualFlowDataByDate.get(this.appConfig.getTodayString());
            if (data) {
                return data.map(d => {
                    return Object.assign(new CurrencyBalanceData(), d);
                });
            }
        }
        return [];
    }

    transactionSurvivalHorizonData(currency: string): SurvivalHorizonData[] {
        const survivalHorizonData = this.txnSurvivalHorizonDataByCurrency.get(currency.toUpperCase());
        if (survivalHorizonData) {
            return survivalHorizonData.map(d => {
                return Object.assign(new SurvivalHorizonData(), d);
            });
        }
        return [];
    }

    projectionSurvivalHorizonData(currency: string): SurvivalHorizonData[] {
        const survivalHorizonData = this.projectionSurvivalHorizonDataByCurrency.get(currency.toUpperCase());
        if (survivalHorizonData) {
            return survivalHorizonData.map(d => {
                return Object.assign(new SurvivalHorizonData(), d);
            });
        }
        return [];
    }

    getProjections(currency: string, targetName: string, direction: string): Projection[] {
        const key = currency + '.' + targetName + '.' + direction;
        return this.projectionsByCcyTargetName.get(key);
    }

    currencyBalanceSurvivalHorizonData(currency: string): SurvivalHorizonData[] {
        const survivalHorizonData = this.currencyBalanceSurvivalHorizonDataByCurrency.get(currency.toUpperCase());
        if (survivalHorizonData) {
            return survivalHorizonData.map(d => {
                return Object.assign(new SurvivalHorizonData(), d);
            });
        }
        return [];
    }

    historicalData(currency: string, type: HistoricalDataType): HistoricalData[] {
        const historicalDataByCcy = this.historicalDataByTypeByCurrency.get(currency.toUpperCase());
        if (historicalDataByCcy) {
            const historicalData = historicalDataByCcy.get(type);
            if (historicalData) {
                return historicalData.map(d => {
                    return Object.assign(new HistoricalData(), d);
                });
            }
        }
        return [];
    }

    accountBalanceData(currency: string): AccountBalanceData[] {
        const accountBalanceData = this.accountBalanceDataByCurrency.get(currency.toUpperCase());
        return accountBalanceData || [];
    }

    nostroLadderProjectionData(currency: string): NostroLadderProjectionData[] {
        const nostroLadderProjectionDatas = this.nostroLadderProjectionDataByCurrency.get(currency.toUpperCase());
        return nostroLadderProjectionDatas || [];
    }
    getApplicationConfiguration(): ApplicationConfiguration {
        return this.applicationConfiguration;
    }
}

class SnapshotFileNames {
    contractualFileName: string;
    historicalFileName: string;
    openingBalanceFileName: string;
    accountBalanceFileName: string;
    projectionFileName: string;
    nostroLadderProjectionDataFileName: string;

    constructor(todayFolder: string) {
        this.contractualFileName = 'opening/contractual/' + todayFolder + '/contractual.csv000.gz';
        this.historicalFileName = 'historical/historical.csv.gz';
        this.openingBalanceFileName = 'opening/currencybalance/' + todayFolder + '/currencybalance.csv000.gz';
        this.accountBalanceFileName = 'opening/accountbalance/' + todayFolder + '/accountbalance.csv000.gz';
        this.projectionFileName = 'opening/projections.csv';
        this.nostroLadderProjectionDataFileName = 'opening/projections.csv'; // TODO Change this to real one eventually
    }

    allFileNames(): string[] {
        const names = [];
        // names.push(this.contractualFileName);
        names.push(this.historicalFileName);
        // names.push(this.openingBalanceFileName);
        // names.push(this.accountBalanceFileName);
        // names.push(this.projectionFileName);
        // names.push(this.nostroLadderProjectionDataFileName);
        return names;
    }

}

